/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/label-has-for */
import React, { useState, useContext } from 'react';
import classNames from 'classnames';
import { Context } from '../../../../context/AppContext';

import './styles.css';

const Radio = ({ selected, children, className, svg = () => {}, ...props }) => {
  const {
    media: { desktop },
  } = useContext(Context);
  const [hovered, setHovered] = useState();
  const [isChecked, setIsChecked] = useState(props.defaultChecked);
  const onChange = e => {
    const { target } = e || {};
    const { checked } = target || {};
    setIsChecked(checked);
  };
  return (
    <label
      hasfor={props.name}
      className={classNames('Listview__Filters__Radio__root', {
        [className]: className,
        'Listview__Filters__Radio__root--disabled': props.disabled,
        'Listview__Filters__Radio__root--hovered': desktop && hovered,
        'Listview__Filters__Radio__root--checked':
          isChecked && selected === props.value,
      })}
      onMouseEnter={() => {
        setHovered(desktop && !props.disabled && true);
      }}
      onMouseLeave={() => {
        setHovered(false);
      }}
    >
      <span className="Listview__Filters__Radio__hidden">
        {svg((isChecked && selected === props.value) || (desktop && hovered))}{' '}
        {children}
      </span>
      <input type="radio" {...props} onChange={onChange} />
      <span className="Listview__Filters__Radio__checked">
        {svg((isChecked && selected === props.value) || (desktop && hovered))}
        <span className="Listview__Filters__Radio__text">{children}</span>
      </span>
    </label>
  );
};

export default Radio;
